import channelService from './services/ChannelService'

/**
 * Utility script to initialize the channels collection
 * This can be run manually or imported and called from other parts of the application
 */
export async function initializeChannelsCollection() {
  try {
    console.log('🚀 Starting channels collection initialization...')
    
    await channelService.initializeChannelsCollection()
    
    // Get stats to verify
    const stats = await channelService.getChannelStats()
    console.log('📊 Channels collection stats:', stats)
    
    console.log('✅ Channels collection initialization completed successfully!')
    return true
  } catch (error) {
    console.error('❌ Failed to initialize channels collection:', error)
    throw error
  }
}

/**
 * Clear all channels (use with caution!)
 */
export async function clearAllChannels() {
  try {
    console.log('🗑️ Clearing all channels...')
    
    const channels = await channelService.getAllChannels({}, false)
    const deletePromises = channels.map(channel => 
      channelService.deleteChannel(channel.key)
    )
    
    await Promise.all(deletePromises)
    console.log(`✅ Deleted ${channels.length} channels`)
    
    return true
  } catch (error) {
    console.error('❌ Failed to clear channels:', error)
    throw error
  }
}

/**
 * Reset channels collection (clear and recreate)
 */
export async function resetChannelsCollection() {
  try {
    console.log('🔄 Resetting channels collection...')
    
    await clearAllChannels()
    await initializeChannelsCollection()
    
    console.log('✅ Channels collection reset completed!')
    return true
  } catch (error) {
    console.error('❌ Failed to reset channels collection:', error)
    throw error
  }
}

// Export for use in browser console or other scripts
if (typeof window !== 'undefined') {
  window.initializeChannelsCollection = initializeChannelsCollection
  window.clearAllChannels = clearAllChannels
  window.resetChannelsCollection = resetChannelsCollection
} 